import { Translator } from './translator'
import { Location } from './location'

export const translator = new Translator({
  sourceLocale: document.documentElement.lang,
})

export default async function translate() {
  const locations = {
    header: new Location(document.querySelector('.header')),
    menu: new Location(document.querySelector('.menu')),
    [window.location.pathname]: new Location(
      document.querySelector('[data-barba="container"]')
    ),
    footer: new Location(document.querySelector('.footer')),
  }

  translator.registerLocations(locations)

  document.querySelectorAll('[data-lang-switcher]').forEach(wrapper => {
    const toggles = Array.from(wrapper.querySelectorAll('[data-target-locale]'))
    const originalLang = document.documentElement.lang
    const selectedLanguageDisplay = wrapper.querySelector(
      '[data-selected-language]'
    )

    for (const toggle of toggles) {
      toggle.addEventListener('click', async e => {
        e.preventDefault()

        const { targetLocale } = toggle.dataset
        const prevLang = selectedLanguageDisplay.textContent
        try {
          selectedLanguageDisplay.textContent = '...'
          await translator.changeLocale(targetLocale)
          selectedLanguageDisplay.textContent = toggle.textContent
          localStorage.setItem('savedLocale', targetLocale)
        } catch (err) {
          console.error(err)
          selectedLanguageDisplay.textContent = prevLang
        }
      })
    }

    const savedLocale = localStorage.getItem('savedLocale')
    const currentLang = savedLocale || originalLang
    const toggle = toggles.find(t => t.dataset.targetLocale === currentLang)
    if (toggle) {
      toggle.click()
    }
  })
}
